export default {
  SET_ESTA_CARREGANDO (state, carregando) {
    state.estaCarregando = carregando
  },

  SET_LISTA (state, itens) {
    state.lista = itens
  }
}
